/**
 * The technician's "notes seen" markers — the shared store instantiated
 * against the technician read-marker routes. The logic lives in
 * `@vollgas/shared/hooks` (`createNotesSeenStore`, `hasUnreadNote`); this
 * file keeps the app's import path and owns its route prefix, the same
 * way `apps/management`'s `notesSeenStore.ts` owns `/admin/work-orders`.
 */
import { createNotesSeenStore } from '@vollgas/shared/hooks'
import { api } from '@/apis/apiClient'

const store = createNotesSeenStore({ api, basePath: '/technical/work-orders' })

export const markNotesSeen: typeof store.markNotesSeen = store.markNotesSeen
export const useNotesSeenAt: typeof store.useNotesSeenAt = store.useNotesSeenAt
export const useNotesSeenReady: typeof store.useNotesSeenReady = store.useNotesSeenReady
export const __resetNotesSeenForTests: typeof store.__resetForTests = store.__resetForTests
export { hasUnreadNote } from '@vollgas/shared/hooks'
export type { SeenMap } from '@vollgas/shared/hooks'
